import { type TileIndex } from "@/types/tile";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import TileEntity from "../TileEntity";

class ArmamentsTraderBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.ARMAMENTS_TRADER;

	public get suppliesTileIndexes(): Set<TileIndex> {
		//  zasobuje len 1 barracks, archers srange, stable
		const uniqueByFrameName = Array.from(super.suppliesTileIndexes)
			.map(
				(
					tileIndex: TileIndex,
				): { tileIndex: TileIndex; frameName: FrameName } | null => {
					const tileId =
						this.tilerepo.getTileIdByTileIndex(tileIndex);
					if (!tileId) return null;

					const frameName =
						this.tilerepo.getFrameNameByTileId(tileId);
					if (!frameName) return null;

					return { tileIndex, frameName };
				},
			)
			.filter(
				(
					item: { tileIndex: TileIndex; frameName: FrameName } | null,
					index: number,
					array: Array<{
						tileIndex: TileIndex;
						frameName: FrameName;
					} | null>,
				): boolean =>
					!!item &&
					index ===
						array.findIndex(
							(
								i: {
									tileIndex: TileIndex;
									frameName: FrameName;
								} | null,
							): boolean => !!i && i.frameName === item.frameName,
						),
			)
			.map(
				(
					item: { tileIndex: TileIndex; frameName: FrameName } | null,
				): TileIndex => item!.tileIndex,
			);

		return new Set<TileIndex>(uniqueByFrameName);
	}

	public get consumption(): Map<ResourceType, number> {
		const consumption = new Map<ResourceType, number>(super.consumption);

		if (!this.suppliesTileIndexes.size && !this.showConsumptionInfo) {
			for (const resource of consumption.keys()) {
				if (
					[
						ResourceType.FOOD_CONSUMPTION,
						ResourceType.POPULATION_CONSUMPTION,
					].includes(resource)
				)
					continue;

				// consumption.delete(resource);
				consumption.set(resource, 0); // Chceme zobrazovat nulove hodnoty v tile detail.
			}
		}

		return consumption;
	}
}

export default ArmamentsTraderBuildingTileEntity;
